import axios from 'axios';
const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

export default axios.create({
  baseURL: `https://lannainfo.library.cmu.ac.th/2024lannafoodapi/`,
  // baseURL: `http://localhost/2024lannafood/api/`,
  headers: headers,
  withCredentials: false
});